import { Injectable, PLATFORM_ID, Inject, ElementRef } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class IpService {

    public userIP = '';
    public geoLocation = null;
    public geoCountry = '';

    constructor(
        private http: HttpClient,
        @Inject(PLATFORM_ID) private platform: Object
    ) {

    }

    IPGeoLocation() {
        let fetchIPURL = environment.iplocation.fetchIp;
        let fetchGeolocationURL = environment.iplocation.fetchGeolocation;
        return this.http.get(fetchIPURL).pipe(
            switchMap((value: any) => {
                this.userIP = value.ip;
                let url = `${fetchGeolocationURL}/${value.ip}?key=${environment.iplocation.key}`;
                return this.http.get(url);
            })
        );
    }

    /*LoadIp() {
        let fetchIPURL = 'https://jsonip.com';
        return this.http.get(fetchIPURL);
    }*/


}
